import { memo } from "react";
import SelectComponent from "ui-kit/src/SelectComponent/SelectComponent";
import Icon from "../../../../../admin/src/components/Icon";
import { Button } from "../../../../../ui-kit-v2/src/button/button";
import { _ } from "i18n";
import { Loader2 } from "lucide-react";
import { SelectValue } from "ui-kit/src/MultipleSelect/types";

interface ActionBarProps {
	onAddWidget: () => void;
	onResetDefault: () => void;
	currentEventItems: any[];
	activeWidgetView: SelectValue | undefined;
	onNavigateToWidget: (selected: SelectValue) => void;
	onSaveView: () => void;
	isSavingView: boolean;
}

const ActionBar = memo(
	({ onAddWidget, onResetDefault, currentEventItems, activeWidgetView, onNavigateToWidget, onSaveView, isSavingView }: ActionBarProps) => {
		return (
			<div className="action-buttons">
				<Button className="btn btn--grey w-max" onClick={onAddWidget}>
					<Icon icon="zoom-more" size={10} color="dark-grey" />
					&nbsp;{_("gamePage.dataInsights.label.addWidget")}
				</Button>

				<Button className="btn btn--grey w-max" onClick={onResetDefault}>
					{_("gamePage.dataInsights.label.resetDefault")}
				</Button>

				<SelectComponent
					value={activeWidgetView}
					items={[{ value: "", label: "--" }, ...currentEventItems]}
					isCleareable={true}
					placeholder={`${_("gamePage.dataInsights.label.navigateTo")}`}
					handleChange={onNavigateToWidget}
					referenced={true}
				/>

				<Button
					className="btn btn-light-blue btn-save-view w-max"
					onClick={onSaveView}
					disabled={isSavingView}
					iconLeft={isSavingView ? <Loader2 className="animate-spin inline-block ml-1 text-gray-400" size={16} /> : undefined}
				>
					{_("gamePage.dataInsights.label.saveView")}
				</Button>
			</div>
		);
	}
);

export default ActionBar;
